import React, { useState, useEffect, useRef } from "react"; //, useEffect
import { Typography } from "@mui/material";

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import swal from "sweetalert";
import { useTranslation } from "react-i18next";
import * as api from "../../../actions/api";
import DispenserFormData from "./AdjustmentFormData";
import Constants from "../../../services/Constants";
import encryptionService from "../../../services/encryptionService";

import { format } from 'date-fns';
const AddAdjustment = (props) => {
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "adjustment";
  const FacilityId = localStorage.getItem("FacilityId");

  const UserInfo = encryptionService.decryptUserInfo();
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;

  const [selectedDate, setSelectedDate] = useState(
    //new Date()
    format(new Date(), 'yyyy-MM-dd')
  );
  const [generatedInvoiceNo, setGeneratedInvoiceNo] = useState("");
  const [formData, setFormData] = useState({
    TransactionDate: selectedDate,
    AdjTypeId: "",
    TransactionNo: generatedInvoiceNo,
    FacilityId: FacilityId,
    TransactionTypeId: 3,
    PreparedBy: "",
    ApprovedBy: "",
    ItemGroupId: props.match.params.id, //Get the url send id
  });

  const [ManyTableData, setManyTableData] = useState([]);
  const [isPositive, setIsPositive] = useState(true);
  const [updatedDetailGridData, setUpdatedDetailGridData] = useState([]);
  const [IssueToFacility, setIssueToFacility] = useState("");

  const handleRDateChange = (date, field) => {
    let newDate;
    if (date == null) {
      newDate = date;
    } else {
      newDate = format(new Date(date), 'yyyy-MM-dd');
    }
    setFormData({ ...formData, [field]: newDate });
    setErrorObject({ ...errorObject, [field]: null });
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const [errorObject, setErrorObject] = useState({});
  const saveInFlightRef = useRef(false);

  const { id } = useParams();
  const queryClient = useQueryClient();

  let params = {
    menukey: "receive",
    FacilityId: FacilityId,
    TransactionTypeId: 3,
    TransactionDate: "",
  };
  const { data: invoiceNo, refetch } = useQuery([params], api.getInvoiceNo, {
    onSuccess: (data) => {
      setGeneratedInvoiceNo(data);
      let fdata = { ...formData };
      fdata["TransactionNo"] = data;
      setFormData(fdata);
    },
    refetchOnWindowFocus: false,
    refetchOnmount: false,
    refetchOnReconnect: false,
    retry: false,
    staleTime: 0, //1000 * 60 * 60 * 24,
  });

  const { isLoading: isSaveMutating, mutate } = useMutation(api.saveAdjustment, {
    onSuccess: (data) => {
      if (data.status == 200) {
        let route = `/${menukey}/edit/${data.TransactionId}`;
        props.history.push(route);

        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      }
    },
  });

  const runSaveAdjustment = (payload) => {
    if (saveInFlightRef.current) return;
    saveInFlightRef.current = true;
    mutate(payload, {
      onSettled: () => {
        saveInFlightRef.current = false;
      },
    });
  };

  const handleAdd = (NonOrderProductData) => {
    setManyTableData(NonOrderProductData);
    setUpdatedDetailGridData(NonOrderProductData);
  };
  const updateIspositive = (isPosVal) => {
    setIsPositive(isPosVal);
  };

  const handleChange = (e) => {
    if (e == "IssuedToFacility") {
      setErrorObject({ ...errorObject, ["IssueToFacility"]: null });
    } else {
      const { name, value } = e.target;
      if (name == "AdjTypeId") {
        console.log("e.target");
        console.log(e.target);
      }

      let data = { ...formData };
      data[name] = value;
      setFormData(data);
      setErrorObject({ ...errorObject, [name]: null });
    }
  };

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const handleReset = () => {
    setFormData({
      TransactionDate: selectedDate,
      AdjTypeId: "",
      TransactionNo: generatedInvoiceNo,
      FacilityId: FacilityId,
      TransactionTypeId: 3,
      IssueToFacility: IssueToFacility,
      PreparedBy: "",
      ApprovedBy: "",
      ItemGroupId: props.match.params.id, //Get the url send id
    });

    setManyTableData([]);
  };

  const validateForm = (formData) => {
    let validateFields = [
      "TransactionDate",
      "TransactionNo",
      "AdjTypeId",
      "IssueToFacility",
      "PreparedBy",
      "ApprovedBy",
    ];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] =
          DispensingLanguage[lan][menukey]["field is Required !"];
        isValid = false;
      }
    });
    setErrorObject(errorData);
    return isValid;
  };

  const handleSubmit = async (e) => {
    console.log("from submit ");
    if (saveInFlightRef.current || isSaveMutating) return;
    if (validateForm(formData)) {
      let fDtat = {
        ...formData,
        ManyJsonSave: ManyTableData,
        menukey: "adjustment",
        lan: lan,
        UserName: UserName,
      };

      runSaveAdjustment(fDtat);
    }
  };

  const deleteAdjustmentInv = (data) => {
    let newarray = ManyTableData.filter((element) => element !== data);
    setManyTableData(newarray);
  };

  const setUpdatedDetailsGridDataHandler = (rows) => {
    if (rows.datatype == "FormData") {
      setFormData(rows.IssueToFacility);
    } else {
      if (saveInFlightRef.current || isSaveMutating) return;
      if (validateForm(formData)) {
        let fDtat = {
          ...formData,
          ManyJsonSave: rows.data,
          menukey: "adjustment",
          lan: lan,
          UserName: UserName,
        };
        runSaveAdjustment(fDtat);
      }
      setManyTableData(rows.data);
    }
  };

  useEffect(() => {}, [isPositive]);

  return (
    <>
      <DispenserFormData
        errorObject={errorObject}
        addProductForm={true}
        formData={formData}
        handleChange={handleChange}
        handleCheck={handleCheck}
        handleReset={handleReset}
        handleSubmit={handleSubmit}
        ManyTableData={updatedDetailGridData}
        handleRDateChange={handleRDateChange}
        selectedDate={selectedDate}
        deleteAdjustmentInv={deleteAdjustmentInv}
        setUpdatedDetailsGridDataHandler={setUpdatedDetailsGridDataHandler}
        bStockUpdate={props.permissionType}
        handleAdd={handleAdd}
        generatedInvoiceNo={generatedInvoiceNo}
        DisableAddBtn={true}
        isPositive={isPositive}
        updateIspositive={updateIspositive}
        {...props}
        isSubmitting={isSaveMutating}
      />
    </>
  );
};

export default AddAdjustment;
